import { motion } from "framer-motion";
import Seo from "../components/Seo";

export default function Oferta({ serviceName }) {
	return (
		<>
			<Seo
				title={`${serviceName} - Оферта`}
				description="Умная защита от DDoS атак, ботов и кибератак."
			/>
			<div className="relative min-h-screen bg-gray-900 text-white">
				{/* Hero секция */}
				<section className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center px-4">
					<motion.h1
						className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400"
						initial={{ opacity: 0, y: -40 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 1 }}
					>
						Публичная оферта {serviceName}
					</motion.h1>

					<motion.p
						className="text-lg md:text-xl text-gray-300 max-w-3xl mb-8"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ delay: 0.3, duration: 1 }}
					>
						Настоящая оферта определяет условия предоставления услуг {serviceName}, связанных с защитой веб-сайтов, цифровых проектов и безопасной работой в сети.
					</motion.p>
				</section>

				{/* Содержимое оферты */}
				<section className="relative z-10 py-20 bg-gray-800/70 backdrop-blur-sm">
					<div className="max-w-5xl mx-auto px-6 space-y-12">

						{/* 01 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">01. Общие положения</h2>
							<p className="text-gray-300 text-lg leading-relaxed">
								1.1. Настоящая оферта регулирует порядок предоставления услуг {serviceName}.
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								1.2. Принятие оферты осуществляется путем регистрации и/или оплаты услуг.
							</p>
						</motion.div>

						{/* 02 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 0.2, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">02. Описание услуг</h2>
							<p className="text-gray-300 text-lg leading-relaxed">Исполнитель предоставляет доступ к следующим услугам:</p>
							<ul className="list-disc list-inside text-gray-300 space-y-2">
								<li>защита от DDoS-атак и вредоносного трафика;</li>
								<li>глобальное CDN-ускорение и оптимизация контента;</li>
								<li>система мониторинга и аналитики в реальном времени;</li>
								<li>AI-инструменты для фильтрации угроз;</li>
								<li>личный кабинет с управлением тарифами.</li>
							</ul>
						</motion.div>

						{/* 03 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 0.4, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">03. Стоимость и оплата</h2>
							<p className="text-gray-300 text-lg leading-relaxed">
								3.1. Актуальные тарифы размещены в личном кабинете и на сайте {serviceName}.
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								3.2. Оплата осуществляется через доступные платежные системы.
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								3.3. Факт оплаты является акцептом условий настоящей оферты.
							</p>
						</motion.div>

						{/* 04 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 0.6, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">04. Права и обязанности сторон</h2>
							<p className="text-gray-300 text-lg font-semibold">Исполнитель обязуется:</p>
							<ul className="list-disc list-inside text-gray-300 space-y-2 mb-4">
								<li>предоставить доступ к сервису после оплаты;</li>
								<li>обеспечивать стабильную работу серверов;</li>
								<li>информировать Пользователя о плановых работах.</li>
							</ul>

							<p className="text-gray-300 text-lg font-semibold">Пользователь обязуется:</p>
							<ul className="list-disc list-inside text-gray-300 space-y-2">
								<li>не использовать сервис в противоправных целях;</li>
								<li>сохранять конфиденциальность данных для входа;</li>
								<li>не передавать доступ третьим лицам.</li>
							</ul>
						</motion.div>

						{/* 05 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 0.8, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">05. Ограничение ответственности</h2>
							<p className="text-gray-300 text-lg leading-relaxed">
								5.1. Сервис предоставляется «как есть». Исполнитель не несёт ответственности за перебои, вызванные внешними факторами.
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								5.2. Исполнитель не отвечает за убытки, возникшие по вине Пользователя или третьих лиц.
							</p>
						</motion.div>

						{/* 06 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 1.0, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">06. Возврат средств</h2>
							<p className="text-gray-300 text-lg leading-relaxed">
								6.1. Возврат возможен в течение 3 дней, если услуга не была оказана по вине Исполнителя.
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								6.2. Возврат осуществляется на реквизиты, с которых поступила оплата.
							</p>
						</motion.div>

						{/* 07 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 1.2, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">07. Форс-мажор</h2>
							<p className="text-gray-300 text-lg leading-relaxed">
								7.1. Стороны освобождаются от ответственности за обстоятельства, находящиеся вне их контроля.
							</p>
						</motion.div>

						{/* 08 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 1.4, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">08. Прочие условия</h2>
							<p className="text-gray-300 text-lg leading-relaxed">
								8.1. Исполнитель вправе изменять условия оферты без предварительного уведомления.
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								8.2. Пользователь обязан самостоятельно отслеживать изменения.
							</p>
						</motion.div>

						{/* 09 */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 1.6, duration: 0.8 }}
							className="space-y-6"
						>
							<h2 className="text-3xl font-bold text-blue-400">09. Контакты</h2>
							<p className="text-gray-300 text-lg leading-relaxed">
								Email: <a href="mailto:info@shieldai.ru" className="text-blue-400 hover:underline">info@shieldai.ru</a>
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								Телеграм: <a href="https://t.me/shield_ai_bot" className="text-blue-400 hover:underline">@shield_ai_bot</a>
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								Сайт: <a href="/" className="text-blue-400 hover:underline">{serviceName}</a>
							</p>
							<p className="text-gray-300 text-lg leading-relaxed">
								ИНН: <span className="text-gray-200">770906897993</span>
							</p>
						</motion.div>

						{/* CTA */}
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: 1.8, duration: 0.8 }}
							className="text-center mt-16"
						>
							<a
								href="/dashboard"
								className="px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-purple-500 hover:to-pink-500 rounded-2xl text-lg font-semibold shadow-2xl transition-all duration-300 hover:scale-105"
							>
								Начать использовать {serviceName}
							</a>
						</motion.div>
					</div>
				</section>
			</div>
		</>
	);
}

